import * as modelPlayer from 'js-3d-model-viewer';

import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";

export class ModelViewer {
  constructor(private $log: Logger, private $utils: Utils) {
    window.screenY = 10;

    this.initModel();
  }

  private initModel() {
    const modelViewers: NodeListOf<HTMLElement> = document.querySelectorAll('.js-model-viewer');

    modelViewers?.forEach((modelViewer: HTMLElement) => {
      const modelUrl = modelViewer.dataset.model;

      let parentBackgroundColor = window.getComputedStyle(modelViewer.closest('[class*=background-]') as HTMLElement)?.backgroundColor;

      if (parentBackgroundColor == "rgba(0, 0, 0, 0)") {
        parentBackgroundColor = "rgb(255,255,255)";
      }

      const opts = {
        grid: false,
        trackball: false,
        background: parentBackgroundColor
      }

      const scene = modelPlayer.prepareScene(modelViewer, opts);
      scene.camera.far = 100000;

      console.log(scene);

      modelPlayer.loadObject(scene, `${window.location.protocol}//${window.location.host}${modelUrl}`);
    });
  }
}
